import { usePostHogFeatureFlagVariant } from '@percent/cause-dashboard/common/hooks/usePostHogFeatureFlag/usePostHogFeatureFlag'
import { POSTHOG_FEATURE_FLAGS } from '@percent/cause-dashboard/common/hooks/usePostHogFeatureFlag/posthogFeatureFlags'
import { GrantQuestionnaire, GrantQuestionnaireProps } from './GrantQuestionnaire'
import {
  NON_BLOCKING_QUESTIONS,
  QuestionnaireNonBlockingVariant,
  QuestionnaireQuestion,
  resolveNonBlockingVariant
} from './grantAdvisoryBooking.utils'

const NONE: readonly QuestionnaireQuestion[] = []

/*
  Separate component, mounted only for the questionnaire phase: reading a PostHog flag
  reports an exposure, so reading it in the modal would enrol users who never see the
  questionnaire and dilute the readout.
*/
export type GrantQuestionnaireExperimentProps = Omit<GrantQuestionnaireProps, 'nonBlockingQuestions' | 'onStart'> & {
  // Passed as an argument, not reported from an effect: the questionnaire's mount
  // effect fires this before our effects would run.
  onStart: (nonBlockingVariant: QuestionnaireNonBlockingVariant) => void
}

export const GrantQuestionnaireExperiment = ({ onStart, ...props }: GrantQuestionnaireExperimentProps) => {
  const nonBlockingVariant = resolveNonBlockingVariant(
    usePostHogFeatureFlagVariant(POSTHOG_FEATURE_FLAGS.CP_GRANT_ADVISORY_QUESTIONNAIRE_NON_BLOCKING)
  )

  return (
    <GrantQuestionnaire
      {...props}
      onStart={() => onStart(nonBlockingVariant)}
      nonBlockingQuestions={nonBlockingVariant === 'non_blocking' ? NON_BLOCKING_QUESTIONS : NONE}
    />
  )
}
